import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import clsx from 'clsx'

import Button, { AppButtonTypes } from '../ButtonBase/Button'
import useTextContents from 'common/hooks/useTextContents'
import { AppState } from 'store'

import './ButtonBackToPartner.scss'
import { BACK_TO_PARTNER_LINK_TYPES, IBackToPartnerProps } from './BackToPartnerButtonProps'

/**
 * Komponent przycisku "Wróć do partnera" używany na stronach z komunikatami. 
 * Pozwala na powrót do strony partnera bo błędnie zakończonym procesie 
*/
const ButtonBackToPartner = (props: IBackToPartnerProps): JSX.Element | null => {
   const DELAY_BEFORE_REDIRECT_IN_SEC = 10
   
   const buttonTextContents = useTextContents()
   const failureReturnUrl = useSelector((state: AppState) => state.applicationState.failureReturnUrl)
   const successReturnUrl = useSelector((state: AppState) => state.applicationState.successReturnUrl)
   const [redirectionTime, setRedirectionTime] = useState<number>(DELAY_BEFORE_REDIRECT_IN_SEC)


   const { className, linkType } = props
   const currentlyRedirectionLink = linkType === BACK_TO_PARTNER_LINK_TYPES.FAILURE ? failureReturnUrl : successReturnUrl


   useEffect(() => {
      if(redirectionTime > 0){
        const timeoutId = setTimeout(()=>{setRedirectionTime(redirectionTime - 1)}, 1000);
  
        return () => {
          clearTimeout(timeoutId)
        }
      }
  
      window.location.href = currentlyRedirectionLink // Gdy skończy się odliczanie, robimy redirect'a na adres url
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [redirectionTime])
 

   if(currentlyRedirectionLink?.length === 0 ) {
      return null
   }

   return (
      <Link to={currentlyRedirectionLink}>
         <Button
            uiButtonType={AppButtonTypes.PRIMARY}
            buttonContent={buttonTextContents(props.isFromVideoVerification? 'buttons.videoVerificationBackToIdentification' : 'buttons.backToPartner')}
            className={clsx('page-back-to-partner-button', className !== undefined && className)}
         />
      </Link>
   )
}

export default ButtonBackToPartner